import * as React from "react";
import { FlexContainer } from "../grid/flexcontainer";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const localNavClass = css({
    userSelect: "none",
    backgroundColor: getThemeColorVar("background", "light"),
    height: "64px",
    paddingLeft: "40px",
    whiteSpace: "nowrap",
});
const localNavButtonClass = css({
    fontSize: "16px",
    paddingLeft: "32px",
    paddingRight: "32px",
    color: getThemeColorVar("typo", "default"),
    cursor: "pointer",
});
const localNavSelectedClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    cursor: "inherit",
    color: getThemeColorVar("primary", "default"),
});
export class LocalNav extends React.Component {
    render() {
        return (React.createElement("div", { className: cx(localNavClass) },
            React.createElement(FlexContainer, { direction: "col" },
                React.createElement(FlexContainer, { direction: "row" }, this.props.values.map((value) => {
                    const classes = [localNavButtonClass];
                    if (value === this.props.selected) {
                        classes.push(localNavSelectedClass);
                    }
                    const translatedValue = this.props.translate
                        ? this.props.translate(value)
                        : value;
                    return (React.createElement("div", { key: value, onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.props.onSelect && this.props.onSelect(value);
                        }, className: cx(classes) },
                        React.createElement(FlexContainer, { direction: "col", "md-justify": "center" }, translatedValue)));
                })))));
    }
}
export default LocalNav;
//# sourceMappingURL=localnav.js.map